import { useState, type MouseEvent } from "react";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { IconButton } from "@covertree/ui/buttons/IconButton";

import { ActionMenuItem } from "./buildEndorsementActions";

interface EndorsementMeatballMenuProps {
  actions: ActionMenuItem[];
}

export function EndorsementMeatballMenu({
  actions,
}: EndorsementMeatballMenuProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (e: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        aria-label="Options"
        onClick={handleOpen}
        sx={(theme) => ({
          width: theme.spacing(5),
          height: theme.spacing(5),
          border: `1px solid ${theme.palette.grey[200]}`,
          "&:hover": {
            borderColor: theme.palette.grey[300],
            bgcolor: theme.palette.action.hover,
          },
        })}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}>
        {actions.map((action) => (
          <MenuItem
            key={action.label}
            onClick={() => {
              action.onClick();
              handleClose();
            }}
            sx={action.color ? { color: action.color } : undefined}>
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
